import React from 'react';
import {withState, t} from 'shared/core';
import Input from 'shared/components/Input';
import ObjectSelect2 from 'shared/components/ObjectSelect2';
import {FormLayout} from 'shared/components/forms';
import Select2 from 'shared/components/Select2';
import LabelHelper from 'shared/components/LabelHelper';
import AnnotatablePdfPreview from 'main/components/pdf/annotate/components/AnnotatablePdfPreview';
import {observer} from 'mobx-react';
import {DocumentAnnotationFormState} from '../state';

const DocumentAnnotationForm = observer(({document, errors, onSave, onCancel, uiState, folders}) => {
  const {recipientOptions, employees} = uiState;

  return (
    <div className='mt3'>
      <FormLayout>
        <Input
          label='company_settings.documents.Company Document Name'
          errorMessage={errors.name}
          type='text'
          value={document.name}
          onChange={(e) => document.merge({name: e.target.value})}/>
        <Select2
          label='company_settings.documents.Language'
          value={document.locale}
          onChange={(e) => document.merge({locale: e.target.value})}>
          <option value='en'>{'English'}</option>
          <option value='fr'>{'Français'}</option>
        </Select2>
        <ObjectSelect2
          value={document.notificationRecipients}
          onAdd={recipient => document.addRecipient(recipient)}
          onRemove={recipient => document.removeRecipient(recipient)}
          items={recipientOptions}
          label='company_settings.documents.Notify on Completion'
          placeholder='company_settings.documents.e.g., Manager'
          by='value'
          multiple
          searchable={true}
        />
        {folders &&
          <ObjectSelect2
            label='employees.profile.documents.Upload to Folder on Completion'
            items={folders}
            value={folders.find(f => f.id === document.folderId)}
            onChange={value => document.merge({folderId: value ? value.id : null})}
            allowClear
            optional
          />
        }
        <div>
          <LabelHelper label={t('company_settings.documents.Company Document Annotations')}/>
          <AnnotatablePdfPreview
            employees={employees}
            companyDocument={document}
            pdfUrl={document.originalFile.preview}
            errors={errors}
            onSave={(annotations) => onSave(annotations)}
            onCancel={() => onCancel()}
          />
        </div>
      </FormLayout>
    </div>
  );
});

export default withState(DocumentAnnotationForm, DocumentAnnotationFormState);
